import { Box, Stack, Typography } from "@mui/material";
import React, { PropsWithChildren } from "react";
import styles from "./Step.module.css";

type Colors = {
	textColor: string;
	borderColor: string;
	backgroundColor: string;
	iconBackgroundColor: string;
};

type StepProps = {
	icon: React.ReactNode;
	color: Colors;
	number: number;
	title: string;
	description: string;
	isLastStep?: boolean;
};

export default function Step({
	icon,
	color,
	number,
	title,
	description,
	isLastStep = false,
}: StepProps & PropsWithChildren) {
	return (
		<Stack direction="row" gap="20px">
			<Stack alignItems="center" height="100%" gap="4px">
				<Box
					className={styles.iconWrapper}
					boxShadow={`0px 0px 0px 4px ${color.iconBackgroundColor}`}
					bgcolor={color.iconBackgroundColor}
				>
					{icon}
				</Box>
				{!isLastStep && <div className={styles.bar} />}
			</Stack>
			<Stack
				direction="row"
				gap="12px"
				marginBottom="21.75px"
				borderColor={color.borderColor}
				bgcolor={color.backgroundColor}
				className={styles.box}
			>
				<Box className={styles.numberWrapper} borderColor={color.borderColor}>
					<Typography color={color.textColor} className={styles.number}>
						{number}
					</Typography>
				</Box>
				<Stack gap="4px">
					<Typography color={color.textColor} className={styles.title}>
						{title}
					</Typography>
					<Typography className={styles.description}>{description}</Typography>
				</Stack>
			</Stack>
		</Stack>
	);
}
